import React from "react";
import "./LegalNotice.css";

import { useTranslation } from "react-i18next";
import i18n from "i18next";

const EnvSocial = () => {
  const { t } = useTranslation();

  document.title = t("page-title.environment_social");

  var lang = i18n.language;
  const [lang_p1, lang_p2] = lang.split("_");

  return (
    <div className="UILegalNotice">
      <div className="container-fluid background">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-7 mx-auto">
              <div className="heading text-center">
                <h1>{t("pages.environment_social")}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container content">
        <div className="text">
          <p>{t("environment_social.text_1")}</p>
          {lang.includes("_si") && (
          <>
          <p className="mb-2">{t("environment_social.text_2")}</p>
          <ul>
            <li>{t("environment_social.text_3")} <a href={('/documents/'+lang_p2+'/NGEN_BESS_NTS_en.pdf')} target="_blank">{t("environment_social.file_1")}</a></li>
            <li>{t("environment_social.text_4")} <a href={('/documents/'+lang_p2+'/NGEN_BESS_NTS.pdf')} target="_blank">{t("environment_social.file_1")}</a></li>
          </ul>
          <p className="mb-2">{t("environment_social.text_5")}</p>
          <ul>
            <li>{t("environment_social.text_3")} <a href={('/documents/'+lang_p2+'/NGEN_BESS_Stakeholder_Engagement_en.pdf')} target="_blank">{t("environment_social.file_2")}</a></li>
            <li>{t("environment_social.text_4")} <a href={('/documents/'+lang_p2+'/NGEN_BESS_Stakeholder_Engagement.pdf')} target="_blank">{t("environment_social.file_2")}</a></li>
          </ul>
          </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EnvSocial;
